module.exports = __webpack_public_path__ + "img/1562272219.66a7bd94.jpg";